import { FigureVarDataDto, isFigureVarDataDto } from "./FigureVarDataDto";

/**
 * Represents a data group (series) within a figure.
 */
export interface FigureGroupDataDto extends Record<string, string | FigureVarDataDto[]> {
  id: string;
  dataGroupName: string;
  dataGroupLabel: string;
  properties: FigureVarDataDto[];
}

/**
 * Type guard to check if an object is a FigureGroupDataDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the figure data group shape.
 */
export const isFigureGroupDataDto = (obj: unknown): obj is FigureGroupDataDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureGroupDataDto;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.dataGroupName !== "string") {
    return false;
  }
  if (typeof chkObj.dataGroupLabel !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((property) => !isFigureVarDataDto(property))) {
    return false;
  }
  return true;
};
